import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckChatGroupLengthPipe } from './check-chat-group-length.pipe';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CheckChatGroupLengthPipe
  ],
  exports: [
    CheckChatGroupLengthPipe
  ]
})
export class CheckChatGroupLengthModule { }
